import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../../hooks/language/language";
import { APP_ROUTES } from "../../../routes/routes.constants";
import { getUrlWithLang } from "../../../routes/routes.functions";
import { LinkStyled } from "../../../components/base-components/base-componets";
import { ALL_ID, ModeAndTeam } from "../../../api/mode-stats/mode-stats.types";
import { AllModesContainer, AllModesTextContainer, ImageModeContainer, ModeContainer, ModeContainerBtn, ModeName, ModesGridContainer } from "./modes-options.styles";
import { MODE_PARAM, TEAM_PARAM } from "../modes.constants";
import { formatNameToTitleCase, getImageSrc, getModeColor } from "../../../shared/functions";
import { modeToUrlMode } from "../../../api/mode-stats/mode-stats";
import { analytics } from "../../../configuration/firebase";
import { logEvent } from "firebase/analytics";

interface Props {
  selectedMode: ModeAndTeam;
  modeOptions: ModeAndTeam[];
  onClickMode: (mode: ModeAndTeam) => void;
}

export const ModesOptions: React.FC<Props> = ({
  selectedMode,
  modeOptions,
  onClickMode
}: Props) => {
  const { t } = useTranslation();
  const { getLanguage } = useLanguage();
  const language = getLanguage()
  const [baseModeUrlLang, setBaseModeUrlLang] = useState<string>(getUrlWithLang(language, APP_ROUTES.MODES));

  useEffect(() => {
    setBaseModeUrlLang(getUrlWithLang(language, APP_ROUTES.MODES));
  }, [language]);


  return (
    <Box>
      <AllModesContainer>
        <LinkStyled
          to={baseModeUrlLang}
          onClick={() => onClickMode({ mode: ALL_ID, teamComposition: ALL_ID })}
          aria-label={t("PAGES.MODES.ALL_MODES")}>
          <ModeContainerBtn isSelected={ALL_ID === selectedMode.mode}>
            <AllModesTextContainer>
              <Typography component="h3">
                {t("PAGES.MODES.ALL_MODES")}
              </Typography>
            </AllModesTextContainer>
          </ModeContainerBtn>
        </LinkStyled>
      </AllModesContainer>
      <ModesGridContainer>
        {modeOptions.map((mode) => (
          <LinkStyled
            to={`${baseModeUrlLang}?${MODE_PARAM}=${modeToUrlMode(mode.mode)}&${TEAM_PARAM}=${modeToUrlMode(mode.teamComposition)}`}
            key={mode.mode + "--" + mode.teamComposition}
            onClick={() => onClickMode(mode)}
            aria-label={t("SHARED.MODE") + " " + mode}>
            <ModeContainer
              isSelected={mode.mode === selectedMode.mode && mode.teamComposition === selectedMode.teamComposition}
              modeColor={getModeColor(mode.mode)}>
              <ImageModeContainer
                component="img"
                alt={`${mode} Logo`}
                src={getImageSrc(`/images/modes/${mode.mode.replace("_5V5", "")}.webp`)}
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.src = getImageSrc('/images/modes/UNTRACKED.webp');
                  logEvent(analytics, 'image_error', {
                    name: mode.mode,
                  });
                }}
              />
              <ModeName>
                {mode
                  ? t(`DOMINE.MODE.${mode.mode.replace("_5V5", "")}`, {
                    defaultValue: formatNameToTitleCase(mode.mode.replaceAll("_", " ").toLowerCase() ?? ""),
                  }) + (mode.teamComposition === "TEAM_2T_5P" ? " 5v5" : "")
                  : ""}
              </ModeName>
            </ModeContainer>
          </LinkStyled>
        ))}
      </ModesGridContainer>
    </Box>
  );
}
